import { ProgressSpinner } from 'primereact/progressspinner';
import React from 'react';
import styled from 'styled-components';

const PageLoader: React.FunctionComponent = () => (
  <LoaderArea>
    <ViewportCenter>
      <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" />
    </ViewportCenter>
  </LoaderArea>
);

const LoaderArea = styled.div`
  grid-column: 1 / -1;
  width: 100%;
  min-height: 515px;
`;

// Pinned to the viewport so the spinner sits in the same place whatever the host page's padding is.
const ViewportCenter = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  .p-progress-spinner-circle {
    stroke: ${(props) => props.theme.colors.primaryOrange};
    animation: p-progress-spinner-dash 2s ease-in-out infinite;
  }
`;

export default PageLoader;
